import { useEffect, useState } from "react";
import { GET_ALL_MOVIE_RATING, GET_ALL_MOVIE_RESOURCE, fetchData } from "../../../components/Service";
import { Link } from "../../../../node_modules/react-router-dom/dist/index";

const MovieReview = () => {
	const [reviews, setReview] = useState([]);
	const [resourceData, setResourceData] = useState([]);

	const getMovieReviews = () => {
		fetchData(GET_ALL_MOVIE_RATING, "GET", "", false, false, (res) => {
			if (res.status) {
				setReview(res?.data?.data);
			} else {
				console.log(res);
			}
		});
	};

	const getMovieResource = () => {
		fetchData(GET_ALL_MOVIE_RESOURCE, "GET", "", false, false, (res) => {
			if (res.status) {
				setResourceData(res?.data);
			} else {
				console.log(res);
			}
		});
	};

	useEffect(() => {
		getMovieReviews();
		getMovieResource();
	}, []);
	return (
		<>
			{reviews && reviews.length > 0 && (
				<div className="container-fluid mb-1 ">
					<div className="card card-forum ">
						<div className="card-header usa-bg">
							<div className="national-bg">
								<h4 className="text-white d-flex ind1">Movie Reviews</h4>
							</div>
						</div>
						<div className="card-body p-1">
							<div className="row">
								{reviews?.slice(0, 6)?.map((item) => {
									let ratings = JSON.parse(item?.rating_data);
									return (
										<div key={item.id} className="col-xxl-2 col-xl-2 col-lg-4 col-md-4 col-6 event_n align-self-stretch mb-1">
											<Link to={`/movie-reviews/${item.id}`} className="text-white">
												<div
													className="card-grid-2 hover-up h-100 mb-0"
													style={{ background: `linear-gradient(rgba(0, 0, 0, 0.45), rgba(0, 0, 0, 0.45)), url(${item.image})`, backgroundSize: "cover" }}
												>
													<div className="card-block-info position-relative">
														<h5 className="movie-name text-white">{item.name}</h5>
														<div className="rate mt-2">
															<input type="radio" id={`star${item.id}5`} name={`star${item.id}5`} disabled value="5" checked={item.average_rating >= 5} />
															<label htmlFor={`star${item.id}5`} title="text">
																5 stars
															</label>
															<input type="radio" id={`star${item.id}4`} name={`star${item.id}4`} disabled value="4" checked={item.average_rating >= 4} />
															<label htmlFor={`star${item.id}4`} title="text">
																4 stars
															</label>
															<input type="radio" id={`star${item.id}3`} name={`star${item.id}3`} disabled value="3" checked={item.average_rating >= 3} />
															<label htmlFor={`star${item.id}3`} title="text">
																3 stars
															</label>
															<input type="radio" id={`star${item.id}2`} name={`star${item.id}2`} disabled value="2" checked={item.average_rating >= 2} />
															<label htmlFor={`star${item.id}2`} title="text">
																2 stars
															</label>
															<input type="radio" id={`star${item.id}1`} name={`star${item.id}1`} disabled value="1" checked={item.average_rating >= 1} />
															<label htmlFor={`star${item.id}1`} title="text">
																1 star
															</label>
														</div>
														<div className="table-responsive">
															<table className="table test-white  mb-0  table-borderless table-sm">
																<tbody>
																	{resourceData?.slice(0, 5)?.map((item, index) => (
																		<tr key={item.id}>
																			<td className="p-0 text-white font14">{item?.name}:</td>
																			<td className="p-0 text-white font14">{ratings[item.id] && ratings[item.id][0] ? ratings[item.id][0] : 0}</td>
																		</tr>
																	))}
																</tbody>
															</table>
														</div>
													</div>
												</div>
											</Link>
										</div>
									);
								})}
								<div className="col-md-12 text-center">
									<Link to={`/movie-reviews`} className="btn btn-warning fw-bold mx-auto">
										Read More
									</Link>
								</div>
							</div>
						</div>
					</div>
				</div>
			)}
		</>
	);
};

export default MovieReview;
